import React from "react";
import { useState } from "react";
import {
  Autocomplete,
  Button,
  Card,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import NumberFormatting from "../../helper/NumberFormatting";
import {
  getStockVegetablesById,
  stockVegetablesActions,
  updateStockVegetables,
} from "../../../redux/reducer/stock-vegetables/stockVegetablesReducer";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import { useEffect } from "react";
import { postDataWithParams } from "../../../service/Service";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminStockVegetablesEdit() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.dataToken);
  const farmer = useSelector((state) => state.farmer.data);
  const data = useSelector((state) => state.stockVegetables.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerId: "",
    vegetablePriceId: "",
    stockIn: "",
    stockOut: "",
    stockTotal: "",
    description: "",
  });

  const [fetch, setFetch] = useState(true);
  const [vegetablePrice, setVegetablePrice] = useState([]);

  useEffect(() => {
    if (fetch) {
      let x = data.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        let body = {};
        let params = {
          paginate: false,
        };
        postDataWithParams(
          "/master/vegetable-price/search",
          token,
          body,
          params
        )
          .then((res) => {
            if (res.data.status === 200) {
              let farmerType = res.data.data.docs.filter(
                (item) => item.priceTypeId?.typeName === "farmers"
              );
              setVegetablePrice([...farmerType]);
              setAutoCompleteValue(data.docs[x].vegetablePriceId);
            } else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            toast.error(err.response.message);
          });
        setFormData({
          farmerId: data.docs[x].farmerId ? data.docs[x].farmerId._id : "",
          farmerName: data.docs[x].farmerId
            ? data.docs[x].farmerId.fullName
            : "",
          vegetablePriceId: data.docs[x].vegetablePriceId
            ? data.docs[x].vegetablePriceId._id
            : "",
          vegetableName: data.docs[x].vegetablePriceId
            ? data.docs[x].vegetablePriceId.vegetableName
            : "",
          stockIn: data.docs[x].stockIn ? data.docs[x].stockIn : 0,
          stockOut: data.docs[x].stockOut ? data.docs[x].stockOut : 0,
          stockTotal: data.docs[x].stockTotal ? data.docs[x].stockTotal : 0,
          description: data.docs[x].description ? data.docs[x].description : "",
        });
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    if (e.target.name === "stockIn") {
      setFormData({
        ...formData,
        ["stockIn"]: parseInt(e.target.value),
        ["stockOut"]: 0,
      });
    } else if (e.target.name === "stockOut") {
      setFormData({
        ...formData,
        ["stockIn"]: 0,
        ["stockOut"]: parseInt(e.target.value),
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          id: id,
          value: {
            farmerId: formData.farmerId,
            vegetablePriceId: formData.vegetablePriceId,
            stockIn: formData.stockIn > 0 ? formData.stockIn : 0,
            stockOut: formData.stockOut > 0 ? formData.stockOut : 0,
            stockTotal: formData.stockTotal,
            description: formData.description,
            createdBy: user.username,
            updatedBy: user.username,
          },
          token: token,
        };
        dispatch(updateStockVegetables(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getStockVegetablesById(dataGetById)).then((result) => {
              dispatch(
                stockVegetablesActions.editStockVegetables(result.payload.data)
              );
              toast.success(res.payload.message);
              navigate("/admin/stock-sayuran");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  const [autoCompleteValue, setAutoCompleteValue] = useState();

  const handleVegetablePrice = (e) => {
    setAutoCompleteValue(e);
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT STOCK SAYURAN
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.farmerName && formData.farmerId.length > 0 && (
                <MenuItem value={formData.farmerId} key={0}>
                  {formData.farmerName}
                </MenuItem>
              )}
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SAYURAN
            </Typography>
            {typeof autoCompleteValue !== "undefined" && (
              <Autocomplete
                id="auto-complete"
                autoComplete
                fullWidth
                value={autoCompleteValue}
                onChange={(event, newValue) => {
                  handleVegetablePrice(newValue);
                }}
                options={vegetablePrice}
                getOptionLabel={(option) => `${option.vegetableName}`}
                includeInputInList
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    name="vegetablePriceId"
                    style={{
                      maxWidth: "400px",
                      background: "white",
                      marginRight: "10px",
                      marginLeft: "27px",
                      marginTop: "10px",
                    }}
                  />
                )}
              />
            )}
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              STOCK MASUK
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              disabled={formData.stockOut > 0}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="stockIn"
              onChange={handleChange}
              value={formData.stockIn}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              STOCK KELUAR
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              disabled={formData.stockIn > 0}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="stockOut"
              onChange={handleChange}
              value={formData.stockOut}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              STOCK TOTAL
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="stockTotal"
              onChange={handleChange}
              value={formData.stockTotal}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KETERANGAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="description"
              onChange={handleChange}
              value={formData.description}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/stock-sayuran")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
